import { loginVendor, registerVendor, getProfile } from '../services/vendorAPI';
import toast from 'react-hot-toast';
import { identifyUser, trackEvent } from '../utils/posthogProvider';
import usePushNotifications from './usePushNotifications';

const useAuth = () => {
  const { requestPermissionAndGetToken } = usePushNotifications();

  const loginUser = async data => {

    try {
      const response = await loginVendor(data.email, data.password);
      if (response.success) {
        // Get profile after login to get vendor ID
        const profileResponse = await getProfile();
        if (profileResponse.success && profileResponse.data) {
          let vendorData = profileResponse.data;

          // Handle array response
          if (Array.isArray(vendorData)) {
            vendorData = vendorData[0];
          }

          if (vendorData) {
            const vendorId = vendorData.id;
            const vendorEmail = vendorData.email;

            // Identify user in PostHog only if vendorId exists
            if (vendorId) {
              // Use email as the distinct ID for better tracking across platforms
              identifyUser(vendorEmail, {
                $email: vendorEmail,
                $name: vendorData.name,
                vendor_id: vendorId, // Add vendor_id as a property
                email: vendorEmail,
                name: vendorData.name,
                country: vendorData.country,
              });

              // Track successful login
              trackEvent('vendor_login_success', {
                vendor_id: vendorId,
                email: vendorEmail,
              });
            } else {
              // Track login without vendor ID
              trackEvent('vendor_login_success', {
                email: vendorEmail || data.email,
              });
            }

            return {
              id: vendorId,
              email: vendorEmail,
              status: true,
            };
          }
        }

        // Track login without profile
        trackEvent('vendor_login_success', {
          email: data.email,
        });

        // Request Notification Permission and Sync Token
        requestPermissionAndGetToken();

        return {
          email: data.email,
          status: true,
        };

      } else {
        // Track failed login
        trackEvent('vendor_login_failed', {
          email: data.email,
          error: response.error,
        });

        toast.error(response.error || 'Login failed');
        return { ...response, status: false };
      }
    } catch (error) {
      // Track login error
      trackEvent('vendor_login_failed', {
        email: data.email,
        error: error.message,
      });

      toast.error(error.message || 'Login failed');
      return { success: false, error: error.message, status: false };
    }
  };

  const registerUser = async data => {
    try {
      const response = await registerVendor({
        name: data.name || '',
        email: data.email,
        password: data.password,
        country: data.country,
      });

      if (response.success) {
        // Track successful registration
        trackEvent('vendor_registration_success', {
          email: data.email,
          country: data.country,
          name: data.name,
        });

        toast.success(
          'Registration Successful. Welcome! Your account has been created.'
        );
        return response;
      } else {
        // Track failed registration
        trackEvent('vendor_registration_failed', {
          email: data.email,
          error: response.error,
        });

        toast.error(response.error || 'Registration failed');
        return response;
      }
    } catch (error) {
      // Track registration error
      trackEvent('vendor_registration_failed', {
        email: data.email,
        error: error.message,
      });

      toast.error(error.message || 'Registration failed');
      return false;
    }
  };

  return { loginUser, registerUser };
};

export default useAuth;
